import React from 'react';
import PropTypes from 'prop-types';
import BasicTagsInput from 'react-tagsinput';
import { useTranslation } from 'react-i18next';

import styles from './TagsInput.scss';

TagsInput.propTypes = {
    id: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

const renderReadonly = (tagComponents) => <span>{tagComponents}</span>;

export default function TagsInput({ id, placeholder, value, disabled, onChange, onBlur }) {
    const { t } = useTranslation('ui');

    return (
        <BasicTagsInput
            tagProps={{ className: styles.tag, classNameRemove: styles.tagRemove }}
            inputProps={{ className: styles.input, id, placeholder: placeholder || t('ui:labels.addTag'), onBlur }}
            value={value}
            addOnBlur
            addOnPaste
            onlyUnique
            disabled={disabled}
            renderLayout={disabled ? renderReadonly: undefined}
            onChange={onChange}
        />
    );
}
